import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import { FaCheckCircle } from 'react-icons/fa';
import { ReportContext } from '../ReportContext';
import { showSwalNotification } from '../../utils/SwalResponse';
import LoadingComponent from '../../utils/LoadingComponent';
import IssueDetails from './IssueDetails';
import IssueReviews from '../../reviews/IssueReviews';

const MotionPaper = motion.create(Paper);

const SingleIssueView = () => {
  const { issueId } = useParams();
  const { fetchSingleIssues, loading } = useContext(ReportContext);
  const [issueData, setIssueData] = useState(null);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    async function handleFetch(issueId) {
      const response = await fetchSingleIssues(issueId);
      if (response.status === 'success') {
        setIssueData(response?.data);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        showSwalNotification(response);
        window.history.back();
      }
    }
    if (!!issueId) {
      handleFetch(issueId);
    }
  }, [issueId, reload]);

  if (!!loading) {
    return <LoadingComponent />;
  }

  return (
    <Box sx={{ py: 4, minHeight: '100vh', display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '100%', maxWidth: '1000px' }}>
        {/* Issue Details Section */}
        <MotionPaper
          elevation={3}
          sx={{ p: 4, borderRadius: 3, mb: 4, position: 'relative' }}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Box display="flex" alignItems="center" mb={2}>
            <FaCheckCircle size={28} style={{ color: 'green', marginRight: '10px' }} />
            <Typography variant="h5" fontWeight="bold" color="success.main">
              Issue Details
            </Typography>
          </Box>

          <IconButton
            onClick={() => window.history.back()}
            sx={{ position: 'absolute', top: 16, right: 16, color: 'error.main' }}
          >
            ❌
          </IconButton>

          <Divider sx={{ my: 2 }} />

          {!!issueData && (
            <IssueDetails reload={reload} setReload={setReload} issue={issueData} />
          )}
        </MotionPaper>

        {/* Reviews Section */}
        {!!issueData?.reviews && (
          <MotionPaper
            elevation={2}
            sx={{ p: 4, borderRadius: 3 }}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <IssueReviews reload={reload} setReload={setReload} issue={issueData} />
          </MotionPaper>
        )}
      </Box>
    </Box>
  );
};

export default SingleIssueView;
